import { useState, useEffect } from "react";
import {
  Modal,
  Button,
  InputGroup,
  FormControl,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";
import classes from "./SearchLoan.module.css";
import urls from "../../Utils/urls";
import { useSelector } from "react-redux";
import { roleType } from "../../Utils/constant";

const SearchLoan = ({ show, onHide }) => {
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);

  const loanReqid = accountOptions.map((data) => data.value).join(" ");
  const roleCondition = selectedRole === roleType.broker ? 1 : 0;

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (query.length >= 2 || query2.length >= 2) {
  //       fetchLoanResults(query, query2);
  //     } else {
  //       setResults([]);
  //     }
  //   }, 300);

  //   return () => clearTimeout(delayDebounce);
  // }, [query, query2]);

  useEffect(() => {
    // Create an AbortController to cancel previous requests
    const abortController = new AbortController();

    const delayDebounce = setTimeout(() => {
      if (query.length >= 2 || query2.length >= 2) {
        fetchLoanResults(query, query2, abortController.signal); // Pass signal to the fetch request
      } else {
        setResults([]);
      }
    }, 300); // Debounce delay time

    // Cleanup function to cancel previous request if query changes
    return () => {
      clearTimeout(delayDebounce);
      abortController.abort(); // Cancel the previous request if it's still ongoing
    };
  }, [query, query2]);

  const fetchLoanResults = async (searchTerm, PropertyAddress, signal) => {
    setLoading(true);
    try {
      const payload = {
        Loanname: searchTerm,
        PropertyAddress: PropertyAddress,
        LenBroRecid: loanReqid,
        is_broker: roleCondition,
      };

      const response = await axios.post(
        urls.dashboard.postLoanLookUp(),
        payload,
        { signal: signal }
      );

      if (response?.data?.[0]) {
        setResults(response?.data?.[0]);
      } else {
        setResults([]);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("Previous POST request aborted");
      } else {
        console.error("Error fetching loan results:", error);
        setResults([]);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onHide();
    setQuery("");
    setQuery2("");
    setResults([]);
  };
  const handleLoanClick = (loan) => {
    handleClose();
    navigate(`/loan-details/${loan.LoanRecID}`);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton className="border-0 p-5">
        <Modal.Title className="d-flex align-items-center gap-2">
          <Icon.Search size={22} />
          <span className="fw-bold">Search Loans</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={classes.modalBody}>
        <div className="row">
          <div className="col-6">
            <InputGroup
              className={`mb-4 shadow-sm col-sm-6 ${classes.searchInputGroup}`}
            >
              <FormControl
                placeholder="Search by loan number..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className={`border-0 ps-4 py-2 rounded-start-pill ${classes.searchInput}`}
                autoFocus
              />
              <InputGroup.Text
                className={`bg-primary text-white p-4 ${classes.searchIcon}`}
              >
                <Icon.Search />
              </InputGroup.Text>
            </InputGroup>
          </div>
          <div className="col-6">
            <InputGroup
              className={`mb-4 shadow-sm col-6 ${classes.searchInputGroup}`}
            >
              <FormControl
                placeholder="Search by property address..."
                value={query2}
                onChange={(e) => setQuery2(e.target.value)}
                className={`border-0 ps-4 py-2 rounded-start-pill ${classes.searchInput}`}
              />
              <InputGroup.Text
                className={`bg-primary text-white p-4 ${classes.searchIcon}`}
              >
                <Icon.Search />
              </InputGroup.Text>
            </InputGroup>
          </div>
        </div>

        {loading && (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {!loading && results.length > 0 && (
          <ListGroup className={`shadow-sm ${classes.resultList}`}>
            {results.map((loan, index) => (
              <ListGroup.Item
                key={index}
                action
                onClick={() => handleLoanClick(loan)}
                className={`d-flex justify-content-between align-items-center py-3 ${classes.loanResult}`}
              >
                <div>
                  <div className="fw-bold">Loan #: {loan.account}</div>
                  {/* <div className="text-muted small">Loan #: {loan.account}</div> */}
                  <div className="text-muted small">
                    <span className="text-primary">Property Address:</span>{" "}
                    {loan?.["Property Address"]}
                  </div>
                </div>
                <Icon.ChevronRight className="text-muted" />
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}

        {!loading && (query || query2) && results.length === 0 && (
          <div className="text-muted text-center py-3">No results found.</div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0">
        {
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        }
      </Modal.Footer>
    </Modal>
  );
};

export default SearchLoan;
